import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

const Loader = ({
    size = 40,
    color = "primary",
    inline = false,
    hover = false,
    ...props
}) => {
  return (
    <div
      className={`flex justify-center items-center ${
        inline ? "w-full h-full" : "fixed inset-0 bg-white/70 z-50"
      }`}
    >
      <CircularProgress size={size} color={hover ? "inherit" : color} {...props} />
    </div>
  );
};

export default Loader;
